/**
 * Single source of truth for SSWS API token storage for the current browser tab.
 * Keys by normalized org hostname so multiple orgs can coexist in one session.
 */

export function storeToken(orgUrl, apiToken) {
  if (!orgUrl || !apiToken) return;
  const key = buildKey(orgUrl);
  try {
    sessionStorage.setItem(key, apiToken);
  } catch (err) {
    console.warn("[tokenVault] Could not store token:", err);
  }
}

export function retrieveToken(orgUrl) {
  if (!orgUrl) return null;
  const key = buildKey(orgUrl);
  try {
    return sessionStorage.getItem(key) ?? null;
  } catch {
    return null;
  }
}

export function clearToken(orgUrl) {
  if (!orgUrl) return;
  const key = buildKey(orgUrl);
  try {
    sessionStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}

export function clearAllTokens() {
  try {
    const keysToRemove = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key?.startsWith("idwiz_token:")) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((k) => sessionStorage.removeItem(k));
  } catch {
    /* ignore */
  }
}

export function hasToken(orgUrl) {
  return Boolean(retrieveToken(orgUrl));
}

function buildKey(orgUrl) {
  try {
    const raw = String(orgUrl).trim();
    const withProto = /^https?:\/\//i.test(raw) ? raw : `https://${raw}`;
    const url = new URL(withProto);
    return `idwiz_token:${url.hostname.toLowerCase()}`;
  } catch {
    return `idwiz_token:${String(orgUrl).toLowerCase().replace(/[^a-z0-9]/g, "_")}`;
  }
}
